import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormOption } from '../../../shared/models/form-option.interface';

@Component({
  selector: 'app-form-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgTemplateOutlet],
  standalone: true,
})
export class SelectOptionComponent implements OnChanges {
  readonly disabled = input<boolean>();
  readonly focused = input<boolean>();
  readonly option = input.required<FormOption>();
  readonly optionTemplate = input<TemplateRef<unknown>>();
  readonly optionSubLabel = input<string>();
  readonly searchTerm = input<string | null>();
  readonly selected = input<boolean>();

  @Output() clicked = new EventEmitter<FormOption>();
  @ViewChild('optionElement', { static: true }) optionElement!: ElementRef;

  labelFragments: string[] = [];
  itemIndex = 0;
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['focused']?.currentValue) {
      this.focus();
    }
    if (changes['option'] || changes['searchTerm']) {
      this.setLabelFragments();
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown = (event: KeyboardEvent): void => {
    if (this.focused() && event.key === 'Enter') {
      this.onClick();
    }
  };

  onClick = (): void => {
    this.clicked.emit(this.option());
  };

  private focus = (): void => {
    this.optionElement.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  };

  private setLabelFragments(): void {
    const option = this.option();
    const searchTerm = this.searchTerm();
    if (option.label && searchTerm) {
      this.labelFragments = option.label.split(
        new RegExp(`(${searchTerm})`, 'gmi'),
      );
      this.changeDetectorRef.detectChanges();
      return;
    }

    this.labelFragments = [option.label];
  }
}
